export default {
  ASC: 'asc',
  DESC: 'desc',
};
